import type { MaybeRefOrGetter } from 'vue';
import { lkitService } from '../services/lkit.service';
import { useQuery } from '@tanstack/vue-query';

export const useLandingPublishers = (landing_id?: MaybeRefOrGetter<number | undefined>) => {
  const landingId = computed(() => toValue(landing_id));

  const { data: publishers, isLoading } = useQuery({
    queryKey: ['landing-publishers', landingId],
    queryFn: () => {
      if (!landingId.value) return;
      return lkitService.getLandingPublishers(landingId.value);
    },
    select: (response) => response?.data.data,
  });

  return {
    //data
    publishers,
    isLoading,
  };
};
